module.exports = __webpack_public_path__ + "img/01n@2x.a3f3f38d.svg";